import { AkebonoCoreModule } from '@akebono/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LetModule } from '@rx-angular/template';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzSpinModule } from 'ng-zorro-antd/spin';

import { GuideModule } from '../guide/guide.module';

import { BidLeaderStatusModule } from '../bid-leader-status/bid-leader-status.module';
import { BidPriorityPassStatusModule } from '../bid-priority-pass-status/bid-priority-pass-status.module';
import { LotAuctionFeedbackModule } from '../lot-auction-feedback/lot-auction-feedback.module';
import { LotAuctionNameModule } from '../lot-auction-name/lot-auction-name.module';
import { LotBidAmountModule } from '../lot-bid-amount/lot-bid-amount.module';
import { LotBoundaryInfoModule } from '../lot-boundary-info/lot-boundary-info.module';
import { LotCheckProductionDateModule } from '../lot-check-production-date/lot-check-production-date.module';
import { LotCountersModule } from '../lot-counters/lot-counters.module';
import { SubscribeToBestBidButtonModule } from '../subscribe-to-best-bid-button/subscribe-to-best-bid-button.module';
import { LotEditAuctionDatetimeComponent } from './components/lot-edit-auction-datetime/lot-edit-auction-datetime.component';
import { LotEditStartPriceComponent } from './components/lot-edit-start-price/lot-edit-start-price.component';
import { LotInfoEditModalComponent } from './components/lot-info-edit-modal/lot-info-edit-modal.component';
import { LotNegotiationsButtonComponent } from './components/lot-negotiations-button/lot-negotiations-button.component';
import { LotParticipationButtonComponent } from './components/lot-participation-button/lot-participation-button.component';
import { LotMainInfoComponent } from './lot-main-info.component';
import { PluralTranslatePipeModule } from '../../../pipes/plural-translate/plural-translate.pipe.module';
import { LotTradingTimeShiftComponent } from './components/lot-trading-time-shift/lot-trading-time-shift.component';
import { GreenCornerTagComponent } from './components/green-corner-tag/green-corner-tag.component';
import { FormatCurrencyPipeModule } from '../../../pipes/format-currency-pipe/format-currency-pipe.module';

@NgModule({
  declarations: [
    LotMainInfoComponent,
    LotEditStartPriceComponent,
    LotEditAuctionDatetimeComponent,
    LotNegotiationsButtonComponent,
    LotParticipationButtonComponent,
    LotInfoEditModalComponent,
    LotTradingTimeShiftComponent,
    GreenCornerTagComponent,
  ],
  imports: [
    CommonModule,
    AkebonoCoreModule,
    LotBoundaryInfoModule,
    SubscribeToBestBidButtonModule,
    NzDescriptionsModule,
    TranslateModule,
    FormsModule,
    NzInputModule,
    NzInputNumberModule,
    NzButtonModule,
    NzStatisticModule,
    NzTypographyModule,
    NzTagModule,
    NzIconModule,
    NzGridModule,
    NzPopoverModule,
    NzDatePickerModule,
    NzFormModule,
    NzModalModule,
    LotCountersModule,
    LotAuctionNameModule,
    LotBidAmountModule,
    LetModule,
    BidPriorityPassStatusModule,
    LotAuctionFeedbackModule,
    GuideModule,
    LotCheckProductionDateModule,
    BidLeaderStatusModule,
    NzCollapseModule,
    PluralTranslatePipeModule,
    NzAlertModule,
    NzSpinModule,
    FormatCurrencyPipeModule,
    NzToolTipModule,
  ],
  exports: [LotParticipationButtonComponent, LotNegotiationsButtonComponent, LotMainInfoComponent],
})
export class LotMainInfoModule {}
